// removed by extract-text-webpack-plugin
module.exports = {"levels":"Levels__levels___2izQD","show":"Levels__show___2mITb","wrapper":"Levels__wrapper___2NeLJ","heading":"Levels__heading___8-eG_","list":"Levels__list___2LG5B","level":"Levels__level___2BnpS","badge":"Levels__badge___QlrID","description":"Levels__description___3PJXY","features":"Levels__features___2LfZJ","active":"Levels__active___oSSvj","disabled":"Levels__disabled___3YYoh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Levels/Levels.css
// module id = 938
// module chunks = 0